export const statusTypes = {
    PENDING: 1,
    APPROVED: 2,
    DENIED: 3,
    PENDING_CANCEL: 4,
    NOT_ASKED: 5,
};
